import React, { useEffect } from "react";
import {
  createBrowserRouter,
  RouterProvider,
  useNavigate,
} from "react-router-dom";

import { Typography } from "@mui/material";
import ManagerHomeView from "../views/ManagerHomeView/ManagerHomeView";
import ManagerSettingsView from "../views/ManagerSettingsView/ManagerSettingsView";
import ManagerTicketView from "../views/ManagerTicketView/ManagerTicketView";
import ManagerTicketsView from "../views/ManagerTicketsView/ManagerTicketsView";
import ManagerCasesView from "../views/ManagerCasesView/ManagerCasesView";
import ManagerUsersView from "../views/ManagerUsersView/ManagerUsersView";
import ManagerUserView from "../views/ManagerUserView/ManagerUserView";
import ManagersView from "../views/ManagersView/ManagersView";
import ManagerCreateTicketView from "../views/ManagerCreateTicketView/ManagerCreateTicketView";
import ManagerCreateUserView from "../views/ManagerCreateUserView/ManagerCreateUserView";
import CreateManagerView from "../views/CreateManagerView/CreateManagerView";
import ManagerCourtsView from "../views/ManagerCourtsView/ManagerCourtsView";
import ManagerCourtView from "../views/ManagerCourtView/ManagerCourtView";
import ManagerCreateCourtView from "../views/ManagerCreateCourtView/ManagerCreateCourtView";
import ManagerCreateProsecutorView from "../views/ManagerCreateProsecutorView/ManagerCreateProsecutorView";
import ManagerCalendarView from "../views/ManagerCalendarView/ManagerCalendarView";
import ManagerBulkNoticesView from "../views/ManagerBulkNoticesView/ManagerBulkNoticesView";
import NotFoundView from "../views/NotFoundView/NotFoundView";
import ManagerView from "../views/ManagerView/ManagerView";
import ManagerPasswordResetView from "../views/ManagerPasswordResetView/ManagerPasswordResetView";
import CaseProgressView from "../views/CaseProgressView/CaseProgressView";
import ManagerMessagesView from "../views/ManagerMessagesView/ManagerMessagesView";
import ManagerMessageView from "../views/ManagerMessageView/ManagerMessageView";
import ManagerAlertsView from "../views/ManagerAlertsView/ManagerAlertsView";
import ManagerProductsView from "../views/ManagerProductsView/ManagerProductsView";
import ManagerProductView from "../views/ManagerProductView/ManagerProductView";
import RevenueDashboardView from "../views/RevenueDashboardView/RevenueDashboardView";

const ManagerAuthRouter = createBrowserRouter(
  [
    {
      path: "/manager-reset-password",
      element: <ManagerPasswordResetView />,
    },
    {
      // Partner case link. Registered in both routers so it opens the same whether or not the
      // visitor happens to have a staff session — a referral partner has no login at all.
      path: "/case/:token",
      element: <CaseProgressView />,
    },
    {
      path: "/",
      element: <ManagerHomeView />,
    },
    {
      path: "/home",
      element: <ManagerHomeView />,
    },
    {
      path: "/settings",
      element: <ManagerSettingsView />,
    },
    {
      path: "/revenue",
      element: <RevenueDashboardView />,
    },
    {
      // Open / closed / all cases, firm-wide. One view; the segment picks the list.
      path: "/cases/:state",
      element: <ManagerCasesView />,
    },
    {
      // Kept reachable so existing bookmarks and links still resolve, but no longer in the menu —
      // the open/closed lists replace it.
      path: "/tickets",
      element: <ManagerTicketsView />,
    },
    {
      path: "/users",
      element: <ManagerUsersView />,
    },
    {
      path: "/user",
      element: <ManagerUserView />,
    },
    {
      path: "/managers",
      element: <ManagersView />,
    },
    {
      path: "/manager",
      element: <ManagerView />,
    },
    {
      path: "/create-manager",
      element: <CreateManagerView />,
    },
    {
      path: "/create-user",
      element: <ManagerCreateUserView />,
    },
    {
      path: "/new-ticket",
      element: <ManagerCreateTicketView />,
    },
    {
      path: "/courts",
      element: <ManagerCourtsView />,
    },
    {
      path: "/create-court",
      element: <ManagerCreateCourtView />,
    },
    {
      path: "/court",
      element: <ManagerCourtView />,
    },
    {
      path: "/add-prosecutor",
      element: <ManagerCreateProsecutorView />,
    },
    {
      path: "/calendar",
      element: <ManagerCalendarView />,
    },
    {
      path: "/bulk-notices",
      element: <ManagerBulkNoticesView />,
    },
    {
      path: "/messages",
      element: <ManagerMessagesView />,
    },
    {
      path: "/message",
      element: <ManagerMessageView />,
    },
    {
      path: "/alerts",
      element: <ManagerAlertsView />,
    },
    {
      path: "/products",
      element: <ManagerProductsView />,
    },
    {
      path: "/product",
      element: <ManagerProductView />,
    },
    // {
    //   path: "/ticket/:ticketGuid",
    //   element: <ManagerTicketView />,
    // },
    {
      path: "/ticket",
      element: <ManagerTicketView />,
    },
    {
      path: "*",
      element: <NotFoundView />,
    },
  ],
  {}
);
export default ManagerAuthRouter;